import React, { useContext } from 'react';
import { APIAlert, Watermark } from '@mummssoftware/common-ui';
import { FormsGlobalContext } from '@mummssoftware/global-context';
import { FajitaIntro } from '../FajitaForms/FajitaIntro';
import { Context } from '../../context';
import { CompletedFormsList } from './CompletedFormsList';
import {
  Container,
  FormScrollWrapper,
  TableScrollWrapper,
} from '../../components/layout/WrapperDiv';

export declare const RouteProps: import('react-router-dom').RouteComponentProps<{
  patientNumber: string;
}>;

type CompletedFormsProps = {
  currentUser: mumms.User;
  appTitle?: string;
  smallWidget?: boolean;
} & typeof RouteProps;

export const CompletedForms = ({ smallWidget }: CompletedFormsProps) => {
  const { watermark, errorInfo, clearError } = useContext(Context);
  const { fajitaQuestionnaireFormGlobal } = useContext(FormsGlobalContext);

  const getExpandedUI = () =>
    fajitaQuestionnaireFormGlobal ? (
      <FormScrollWrapper>
        <FajitaIntro />
      </FormScrollWrapper>
    ) : (
      <TableScrollWrapper>
        <CompletedFormsList />
      </TableScrollWrapper>
    );

  const getUI = () => (smallWidget ? <CompletedFormsList /> : getExpandedUI());

  return (
    <Container id="completed-forms-container">
      <APIAlert
        errorInfo={errorInfo}
        persistentError
        handleClose={() => clearError()}
      />
      {watermark && watermark.show ? (
        <Watermark readOnly={watermark.readOnly} smallWidget={smallWidget} />
      ) : null}
      {getUI()}
    </Container>
  );
};

export default CompletedForms;
